import React from 'react'
import PrimaryButton from '../Button/PrimaryButton/PrimaryButton'
import './FileUpload.scss'

interface IProps {
  onChange?: any,
  noFiles?: boolean,
  file?: any,
  multiple?: boolean,
  value?:any,
  disabled?:any,
  onClick?: any
}
const FileUpload = ({ onChange, noFiles = true, file = '', multiple = false, value,disabled, onClick }: IProps) => {
  return <><div className='file-upload-wrapper'>
    <button className='choose-file' data-attribute="index_Default_Button_3">Choose File</button>
    {
        noFiles ? <span className='nofile-chosen'>No file chosen</span> : <span className='file-name'>{file}</span>
    }
    <input type="file" value={value} name="myfile" disabled = {disabled} className='file-upload' onChange={onChange} multiple={multiple} data-attribute="index_myfile_Input" />
  </div>
  <PrimaryButton onClick={onClick} data-attribute="index_Default_Button_3_2"><span className='fa fa-upload upload-icon'></span> Upload</PrimaryButton>
  </>
}

export default FileUpload
